/**
 * liveSiteEvent.ts
 * ----------------
 * Selector functions for live site event details view in across portals.
 */

import { PortalState } from '../../reducers/shared';

/**
 * Selects loaded live site event from application state.
 * @param state Current application state
 * @returns The current live site event if one is loaded, undefined otherwise
 */
export function selectLiveSiteEvent (state: PortalState) {
    return state.liveSiteEvent.liveSiteEvent;
}

/**
 * Selects error from GET live site event request from application state.
 * @param state Current application state
 * @returns Error from GET live site event request if one occurred, undefined otherwise
 */
export function selectLiveSiteEventError (state: PortalState) {
    return state.liveSiteEvent.getLiveSiteEventError;
}

/**
 * Selects status of GET live site event request from application state.
 * @param state Current application state
 * @returns Status of GET live site event request
 */
export function selectLiveSiteEventStatus (state: PortalState) {
    return state.liveSiteEvent.getLiveSiteEventStatus;
}

/**
 * Selects the ID of the current live site event details view context.
 * @param state Current application state
 * @returns The current live site event ID if the context is set, false otherwise
 */
export function selectLiveSiteEventViewId (state: PortalState) {
    return state.liveSiteEvent.liveSiteEventViewId;
}
